import axios from "axios";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import getUrl from "../../../../constants/urlConst";


export function ApiManager() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: getUrl(),
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  return {
    getManager: async () => {
      try {
        const response = await authAxios.get(getUrl() + "managers");
        return response.data;
      } catch (error) {
        console.error("Error fetching managers:", error);
        throw error;
      }
    },

  };
}
